import {defineMessages} from 'react-intl';
import PropTypes from 'prop-types';

export const messagePropType = PropTypes.shape({
    id: PropTypes.string,
    defaultMessage: PropTypes.string
});

export const messages = defineMessages({
    analyticsTabContent: {
        id: 'analytics.content.tab',
        defaultMessage: "Content"
    },
    analyticsTabDemographics: {
        id: 'analytics.demographics.tab',
        defaultMessage: "Demographics"
    },
    analyticsTabSystem: {
        id: 'analytics.system.tab',
        defaultMessage: "System"
    },
    analyticsTabDevice: {
        id: 'analytics.device.tab',
        defaultMessage: "Device"
    },
    articleListTitle: {
        id: 'articles',
        defaultMessage: 'Articles'
    },
    articleCreated: {
        id: 'article.created.message',
        defaultMessage: "Article created"
    },
    articleUpdated: {
        id: 'article.updated.message',
        defaultMessage: "Article updated"
    },
    articleCreate: {
        id: 'article.create',
        defaultMessage: "Article create"
    },
    articleUpdate: {
        id: 'article.update',
        defaultMessage: "Article update"
    },
    articleDeleted: {
        id: 'article.deleted',
        defaultMessage: 'Article deleted'
    },
    articleErrorDelete: {
        id: 'article.delete.error',
        defaultMessage: 'Could not delete article'
    },
    articleCloned: {
        id: 'article.cloned',
        defaultMessage: 'Article cloned',
    },
    articleDeleteQuestion: {
        id: 'article.delete.question',
        defaultMessage: 'Are you sure you want to delete this article?'
    },
    articleDeleteModalTitle: {
        id: 'article.delete.modal.title',
        defaultMessage: 'Deleting article'
    },
    articleSubHeadingErrorLengthIsToLong: {
        id: 'article.subheading.error.length.is.to.long',
        defaultMessage: "Subheading length must be 150 characters max"
    },
    listColumnTitleHeading: {
        id: 'list.column.title.heading',
        defaultMessage: 'Heading'
    },
    listColumnTitleCategories: {
        id: 'list.column.title.categories',
        defaultMessage: 'Categories'
    },
    listColumnTitlePublishedAt: {
        id: 'list.column.title.published.at',
        defaultMessage: 'Published at'
    },
    listColumnTitlePrice: {
        id: 'list.column.title.price',
        defaultMessage: 'Price'
    },
    listColumnTitleOptions: {
        id: 'list.column.title.options',
        defaultMessage: 'Options'
    },
    listColumnTitleEmail: {
        id: 'list.column.email',
        defaultMessage: 'Email'
    },
    listDivTitleEmail: {
        id: 'list.div.title.email',
        defaultMessage: 'Email:'
    },
    listColumnTitlePhone: {
        id: 'list.column.title.phone',
        defaultMessage: 'Phone'
    },
    listDivTitlePhone: {
        id: 'list.div.title.phone',
        defaultMessage: 'Phone:'
    },
    listDivPrice: {
        id: 'list.div.title.price',
        defaultMessage: 'Price:'
    },
    listDivTitleHeading: {
        id: 'list.div.title.heading',
        defaultMessage: 'Heading:'
    },
    listDivTitleCategories: {
        id: 'list.div.title.categories',
        defaultMessage: 'Categories:'
    },
    listDivTitlePublishedAt: {
        id: 'list.div.title.published.at',
        defaultMessage: 'Published at:'
    },
    listDropDownButtonOptions: {
        id: 'list.drop.down.button.options',
        defaultMessage: 'Options'
    },
    listDropDownButtonDelete: {
        id: 'list.drop.down.button.delete',
        defaultMessage: 'Delete'
    },
    listDropDownButtonEdit: {
        id: 'list.drop.down.button.edit',
        defaultMessage: 'Edit'
    },
    listDropDownButtonClone: {
        id: 'list.drop.down.button.clone',
        defaultMessage: 'Clone'
    },
    listDropDownButtonView: {
        id: 'list.drop.down.button.list',
        defaultMessage: 'View'
    },
    deleteModalConfirmButton: {
        id: 'delete.modal.confirm.button',
        defaultMessage: 'Delete'
    },
    deleteModalCancelButton: {
        id: 'delete.modal.cancel.button',
        defaultMessage: 'Cancel'
    },
    remove: {
        id: 'remove',
        defaultMessage: 'Remove'
    },
    mustFillRequiredFields: {
        id: 'must.fill.required.fields',
        defaultMessage: 'You must fill required fields'
    },
    comments: {
        id: 'comments',
        defaultMessage: 'Comments'
    },
    commentsDescription: {
        id: 'comments.description',
        defaultMessage: 'Allow visitors to post comments and ask questions about the news.'
    },
    contactPerson: {
        id: 'contact.person',
        defaultMessage: 'Contact person'
    },
    contactPersonSelect: {
        id: 'contact.person.select',
        defaultMessage: 'Select contact person'
    },
    contactPersonCloned: {
        id: 'contact.person.cloned',
        defaultMessage: 'Contact person cloned'
    },
    contactPersonErrorDelete: {
        id: 'contact.person.error.delete',
        defaultMessage: 'You can not delete your account'
    },
    contactPersonDeleted: {
        id: 'contact.person.deleted',
        defaultMessage: 'Contact person deleted'
    },
    contactPersonDeleteModalTitle: {
        id: 'contact.person.delete.modal',
        defaultMessage: 'Delete contact person'
    },
    contactPersonDeleteQuestion: {
        id: 'contact.person.delete.question',
        defaultMessage: 'Are you sure you want to delete this contact?'
    },
    contactPersonListTitle: {
        id: 'contact.person.list.title',
        defaultMessage: 'Contact persons'
    },
    contactPersonListColumnTitleName: {
        id: 'contact.person.list.column.title.name',
        defaultMessage: 'Name'
    },
    contactPersonListDivTitleName: {
        id: 'contact.person.list.div.title.name',
        defaultMessage: 'Name:'
    },
    contactPersonListColumnWorkingTitle: {
        id: 'contact.person.list.column.working.title',
        defaultMessage: 'Working title'
    },
    contactPersonListDivWorkingTitle: {
        id: 'contact.person.list.div.working.title',
        defaultMessage: 'Working title:'
    },
    publishedAt: {
        id: 'published.at',
        defaultMessage: 'Published at'
    },
    categories: {
        id: 'categories',
        defaultMessage: 'Categories'
    },
    categoriesSelect: {
        id: 'categories.select',
        defaultMessage: 'Select categories'
    },
    heading: {
        id: 'heading',
        defaultMessage: 'Heading'
    },
    headingPlaceholder: {
        id: 'heading.placeholder',
        defaultMessage: 'Enter heading'
    },
    resume: {
        id: 'resume',
        defaultMessage: 'Resume',
    },
    resumePlaceholder: {
        id: 'resume.placeholder',
        defaultMessage: 'Enter resume'
    },
    images: {
        id: 'images',
        defaultMessage: 'Images'
    },
    image: {
        id: 'image',
        defaultMessage: 'Image'
    },
    files: {
        id: 'files',
        defaultMessage: 'Files'
    },
    optional: {
        id: 'optional',
        defaultMessage: '(optional)'
    },
    catalogs: {
        id: 'catalogs',
        defaultMessage: 'Catalogs, etc.'
    },
    description: {
        id: 'description',
        defaultMessage: 'Description'
    },
    descriptionPlaceholder: {
        id: 'description.placeholder',
        defaultMessage: 'Enter description'
    },
    browse: {
        id: 'browse',
        defaultMessage: 'Browse >>'
    },
    contactPersonCreate: {
        id: 'contact.person.create',
        defaultMessage: 'Create contact person'
    },
    contactPersonDescription: {
        id: 'contact.person.description',
        defaultMessage: 'Choose who in your company there should be a contact person.' +
        ' Among other things, the person will receive an email when a comment is posted on the news.' +
        ' If the desired person is not listed, you must first create him.' +
        ' You can do this from the following page, but be aware that it requires administrator privileges.'
    },
    contactPersonCreated: {
        id: 'contact.person.created',
        defaultMessage: 'Contact person created'
    },
    contactPersonUpdated: {
        id: 'contact.person.updated',
        defaultMessage: 'Contact person updated'
    },
    contactPersonFailedToCreateError: {
        id: 'contact.person.failed.to.create.error',
        defaultMessage: 'Could not create a contact person'
    },
    contactPersonFailedToUpdateError: {
        id: 'contact.person.failed.to.update.error',
        defaultMessage: 'Could not update a contact person'
    },
    contactPersonShowVCard: {
        id: 'contact.person.show.vcard',
        defaultMessage: 'Show contact information like VCARD on the website'
    },
    title: {
        id: 'title',
        defaultMessage: 'Title'
    },
    name: {
        id: 'name',
        defaultMessage: 'Name'
    },
    email: {
        id: 'email',
        defaultMessage: 'E-mail'
    },
    phone: {
        id: 'phone',
        defaultMessage: 'Phone'
    },
    mobilePhone: {
        id: 'phone.mobile',
        defaultMessage: 'Mobile phone'
    },
    directPhoneNumber: {
        id: 'phone.direct.number',
        defaultMessage: 'Direct phone message'
    },
    jobListTitle: {
        id: 'job.list.title',
        defaultMessage: 'Jobs'
    },
    jobDeleteQuestion: {
        id: 'job.delete.question',
        defaultMessage: 'Are you sure you want to delete this job?'
    },
    jobListColumnPublishedAt: {
        id: 'job.list.column.published.at',
        defaultMessage: 'Published adt'
    },
    jobListColumnExpirationDate: {
        id: 'job.list.column.expiration.date',
        defaultMessage: 'Expiration date'
    },
    jobListDivPublishedAt: {
        id: 'job.div.published.at',
        defaultMessage: 'Published at:'
    },
    jobListDivExpirationDate: {
        id: 'job.div.expiration.date',
        defaultMessage: 'Expiration date:'
    },
    jobDeleteModalTitle: {
        id: 'job.delete.modal.title',
        defaultMessage: 'Deleting job'
    },
    jobCreate: {
        id: 'job.create',
        defaultMessage: 'Job create',
    },
    jobUpdate: {
        id: 'job.update',
        defaultMessage: 'Job update'
    },
    allowUsersAskQuestionsJobs: {
        id: 'job.ask.questions',
        defaultMessage: 'Allow visitors to post comments and ask questions about the job posting.'
    },
    jobWorkingTime: {
        id: 'job.working.time',
        defaultMessage: 'Working time'
    },
    active: {
        id: 'active',
        defaultMessage: 'Active'
    },
    inactive: {
        id: 'inactive',
        defaultMessage: 'Inactive'
    },
    region: {
        id: 'region',
        defaultMessage: 'Region'
    },
    category: {
        id: 'category',
        defaultMessage: 'Category'
    },
    status: {
        id: 'status',
        defaultMessage: 'Status'
    },
    startDate: {
        id: 'start.date',
        defaultMessage: 'Start date'
    },
    endDate: {
        id: 'end.date',
        defaultMessage: 'End date'
    },
    advertisementIsCreated: {
        id: 'advertisement.is.created',
        defaultMessage: 'Advertisement is created'
    },
    advertisementIsUpdated: {
        id: 'advertisement.is.updated',
        defaultMessage: 'Advertisement is updated'
    },
    machineFormTitle: {
        id: 'machine.form.title',
        defaultMessage: 'Buy and Sale'
    },
    machineFormContactPersonDescription: {
        id: 'machine.form.contact.person.description',
        defaultMessage: 'Choose who in your company there should be a contact person.' +
        ' The person will, among other things,' +
        ' receive an email when there is a comment about the performance.' +
        ' If the desired person is not listed, you must first create him.' +
        ' You can do this from the following page, but be aware that it requires administrator privileges.'
    },
    maintenanceAlertHeader: {
        id: 'maintenance.alert.header',
        defaultMessage: 'Maintenance!'
    },
    maintenanceAlertContent: {
        id: 'maintenance.alert.content',
        defaultMessage: `Sorry, we're down for maintenance`
    },
    maintenanceAlertFooter: {
        id: 'maintenance.alert.footer',
        defaultMessage: `We'll be back up shortly`
    },
    statistic: {
        id: 'statistic',
        defaultMessage: 'Statistic'
    },
    machineProducer: {
        id: 'machine.producer',
        defaultMessage: 'Producer'
    },
    machineListColumnModel: {
        id: 'machine.list.column.model',
        defaultMessage: 'Model'
    },
    machineListDivModel: {
        id: 'machine.list.div.model',
        defaultMessage: 'Model:'
    },
    machineListColumnYear: {
        id: 'machine.list.column.year',
        defaultMessage: 'Year'
    },
    machineListDivYear: {
        id: 'machine.list.div.year',
        defaultMessage: 'Year:'
    },
    machineModel: {
        id: 'machine.model',
        defaultMessage: 'Model'
    },
    machineYear: {
        id: 'machine.year',
        defaultMessage: 'Year',
    },
    machineReferenceNumber: {
        id: 'machine.number',
        defaultMessage: 'Reference number'
    },
    sendStatisticToContactPerson: {
        id: 'machine.send.statistic',
        defaultMessage: 'Send statistics for the ad per.' +
        ' email to the contact person after ' +
        '1 week and at the time of expiration'
    },
    machinesAllowVisitorsToComment: {
        id: 'machine.allow.visitors.to.post',
        defaultMessage: 'Allow visitors to post comments and ask questions for purchase and sale.'
    },
    machineBuySellRent: {
        id: 'machine.buy.sell.rent',
        defaultMessage: 'Buy/Sell/rent'
    },
    machineNewOrUsed: {
        id: 'machine.new.or.used',
        defaultMessage: 'New/used'
    },
    machineDeleted: {
        id: 'machine.deleted',
        defaultMessage: 'Machine deleted'
    },
    machineErrorDelete: {
        id: 'machine.error.delete',
        defaultMessage: 'Could not delete machine'
    },
    machineCloned: {
        id: 'machine.cloned',
        defaultMessage: 'Machine cloned'
    },
    machineDeleteModalTitle: {
        id: 'machine.delete.modal.title',
        defaultMessage: 'Delete purchase and sales ad'
    },
    machineDeleteQuestion: {
        id: 'machine.delete.question',
        defaultMessage: 'Are you sure you want to delete this ad?'
    },
    machineListTitle: {
        id: 'machine.list.title',
        defaultMessage: 'Buy sale'
    },
    machineCreate: {
        id: 'machine.create',
        defaultMessage: 'Create ad'
    },
    data: {
        id: 'data',
        defaultMessage: 'Data'
    },
    text: {
        id: 'text',
        defaultMessage: 'Text'
    },
    new: {
        id: 'new',
        defaultMessage: 'New'
    },
    used: {
        id: 'used',
        defaultMessage: 'Used'
    },
    expires: {
        id: 'expires',
        defaultMessage: 'Expires'
    },
    service: {
        id: 'service',
        defaultMessage: 'Service'
    },
    serviceCreated: {
        id: 'service.created',
        defaultMessage: 'Service created'
    },
    serviceUpdated: {
        id: 'service.updated',
        defaultMessage: 'Service updated'
    },
    serviceContactPersonDescription: {
        id: 'service.contact.person.description',
        defaultMessage: 'Choose who in your company there should be a contact person.' +
        ' The person will, among other things, receive an email when there is a comment about the performance.' +
        ' If the desired person is not listed, you must first create him.' +
        ' You can do this from the following page, but be aware that it requires administrator privileges.'
    },
    serviceAllowVisitorsToComment: {
        id: 'service.allow.visitors.to.post',
        defaultMessage: 'Allow visitors to post comments and ask questions about services.'
    },
    serviceListTitle: {
        id: 'service.list.title',
        defaultMessage: 'Service'
    },
    serviceListCreateService: {
        id: 'service.list.create',
        defaultMessage: 'Create Service'
    },
    serviceCloned: {
        id: 'service.cloned',
        defaultMessage: 'Service cloned'
    },
    serviceDeleted: {
        id: 'service.deleted',
        defaultMessage: 'Service deleted'
    },
    serviceErrorDelete: {
        id: 'service.error.delete',
        defaultMessage: 'Could not delete performance'
    },
    serviceDeleteModalTitle: {
        id: 'service.delete.modal.title',
        defaultMessage: 'Deletion of performance'
    },
    serviceDeleteQuestion: {
        id: 'service.delete.question',
        defaultMessage: 'Are you sure you want to delete this service?'
    },
    wanted: {
        id: 'wanted',
        defaultMessage: 'Wanted'
    },
    offering: {
        id: 'offering',
        defaultMessage: 'Offering'
    },
    courseCreated: {
        id: 'course.created',
        defaultMessage: 'Course created'
    },
    courseUpdated: {
        id: 'course.updated',
        defaultMessage: 'Course updated'
    },
    courseFormTitle: {
        id: 'course.form.title',
        defaultMessage: 'Arrangement, fair, course'
    },
    country: {
        id: 'country',
        defaultMessage: 'Country'
    },
    municipality: {
        id: 'municipality',
        defaultMessage: 'Municipality'
    },
    address: {
        id: 'address',
        defaultMessage: 'Address'
    },
    city: {
        id: 'city',
        defaultMessage: 'City'
    },
    postalCode: {
        id: 'postal.code',
        defaultMessage: 'Postal code'
    },
    showAddressOnMap: {
        id: 'show.address.on.map',
        defaultMessage: 'Show address on map'
    },
    coordinates: {
        id: 'coordinates',
        defaultMessage: 'Coordinates'
    },
    longitude: {
        id: 'longitude',
        defaultMessage: 'Longitude'
    },
    latitude: {
        id: 'latitude',
        defaultMessage: 'Latitude'
    },
    fetch: {
        id: 'fetch',
        defaultMessage: 'fetch'
    },
    checkOut: {
        id: 'check.out',
        defaultMessage: 'Check out'
    },
    courseAllowComments: {
        id: 'course.allow.comments',
        defaultMessage: 'Allow visitors to write comments and ask questions for event, trade fair, course.'
    },
    additionalInformation: {
        id: 'additional.information',
        defaultMessage: 'Additional information'
    },
    courseAdditionalInformationDescription: {
        id: 'course.additional.information.description',
        defaultMessage: 'Enter the link to a page with more information about the event or the course'
    },
    courseRegistration: {
        id: 'course.registration',
        defaultMessage: 'Course registration'
    },
    courseRegistrationDescription: {
        id: 'course.registration.description',
        defaultMessage: 'Enter the link to a page of registration for the event or course'
    },
    courseContactPersonDescription: {
        id: 'course.contact.person.description',
        defaultMessage: 'Choose who in your company there should be a contact person.' +
        ' The person will, among other things, receive an email when there is a comment about the event or the course.' +
        ' If the desired person is not listed, you must first create him.' +
        ' You can do this from the following page, but be aware that it requires administrator privileges.'
    },
    courseListCreate: {
        id: 'course.list.create',
        defaultMessage: 'Create course'
    },
    courseListCourseDeleted: {
        id: 'course.list.course.deleted',
        defaultMessage: 'Course deleted'
    },
    courseListCourseCloned: {
        id: 'course.list.course.cloned',
        defaultMessage: 'Course cloned'
    },
    courseListErrorDelete: {
        id: 'course.list.error.delete',
        defaultMessage: 'Could not delete course'
    },
    courseDeleteModalTitle: {
        id: 'course.list.delete.modal.title',
        defaultMessage: 'Deleting course'
    },
    courseDeleteQuestion: {
        id: 'course.delete.question',
        defaultMessage: 'Are you sure you want to delete this course?'
    },
    courseListDropDownDeleteButtonHoverText: {
        id: 'course.list.drop.down.delete.button.hover.text',
        defaultMessage: 'Delete'
    },
    courseListTitle: {
        id: 'course.list.title',
        defaultMessage: 'Courses list'
    },
    courseListColumnTitleRegion: {
        id: 'course.list.column.title.region',
        defaultMessage: 'Region'
    },
    courseListColumnTitleStartDate: {
        id: 'course.list.column.title.start.date',
        defaultMessage: 'Start date'
    },
    courseListColumnTitleEndDate: {
        id: 'course.list.column.title.end.date',
        defaultMessage: 'End date'
    },
    courseListDivTitleRegion: {
        id: 'course.list.div.title.region',
        defaultMessage: 'Region'
    },
    courseListDivTitleStartDate: {
        id: 'course.list.div.title.start.date',
        defaultMessage: 'Start date'
    },
    courseListDivTitleEndDate: {
        id: 'course.list.div.title.end.date',
        defaultMessage: 'End date:'
    },
    type: {
        id: 'type',
        defaultMessage: 'Type'
    },
    catalogCreate: {
        id: 'catalog.create',
        defaultMessage: 'Create catalog'
    },
    catalogListColumnCreatedAt: {
        id: 'catalog.list.column.created.at',
        defaultMessage: 'Created at'
    },
    catalogListColumnTitle: {
        id: 'catalog.list.column.title',
        defaultMessage: 'Title'
    },
    catalogListDivTitle: {
        id: 'catalog.list.div.title',
        defaultMessage: 'Title'
    },
    catalogListDivCreatedAt: {
        id: 'catalog.list.div.create.at',
        defaultMessage: 'Created at'
    },
    catalogListTitle: {
        id: 'catalog.list.title',
        defaultMessage: 'Catalogs'
    },
    catalogListCreateCatalog: {
        id: 'catalog.list.create.catalog',
        defaultMessage: 'Create catalog'
    },
    catalogListCatalogDeleted: {
        id: 'catalog.list.catalog.deleted',
        defaultMessage: 'Catalog deleted'
    },
    catalogListErrorDelete: {
        id: 'catalog.list.error.delete',
        defaultMessage: 'Could not delete catalog'
    },
    catalogListCatalogCloned: {
        id: 'catalog.list.catalog.cloned',
        defaultMessage: 'Catalog cloned'
    },
    catalogListErrorClone: {
        id: 'catalog.list.error.clone',
        defaultMessage: 'An error occurred while trying to copy the #'
    },
    catalogListDeleteModalTitle: {
        id: 'catalog.list.delete.modal.title',
        defaultMessage: 'Delete catalog'
    },
    catalogDeleteModalQuestion: {
        id: 'catalog.list.delete.modal.question',
        defaultMessage: 'Are you sure you want to delete a catalog?'
    },
    catalogUpdate: {
        id: 'catalog.update',
        defaultMessage: 'Update catalog'
    },
    catalogCreated: {
        id: 'catalog.created',
        defaultMessage: 'Catalog created'
    },
    catalogUpdated: {
        id: 'catalog.updated',
        defaultMessage: 'Catalog updated'
    },
    catalogCreateError: {
        id: 'catalog.create.error',
        defaultMessage: 'An error occurred while deleting the directory'
    },
    catalogUpdateError: {
        id: 'catalog.update.error',
        defaultMessage: 'An error occurred while updating the catalog'
    },
    catalogInputTitle: {
        id: 'catalog.input.title',
        defaultMessage: 'Catalog name'
    },
    catalogInputPlaceholder: {
        id: 'catalog.input.placeholder',
        defaultMessage: 'Catalog name'
    },
    catalogFile: {
        id: 'catalog.file',
        defaultMessage: 'Catalog File'
    },
    addressPlaceholder: {
        id: 'address.placeholder',
        defaultMessage: 'Enter Address'
    },
    companyCreate: {
        id: 'company.create',
        defaultMessage: 'Create company'
    },
    companyUpdate: {
        id: 'company.update',
        defaultMessage: 'Company update'
    },
    companyCreated: {
        id: 'company.created',
        defaultMessage: 'Company created'
    },
    companyUpdated: {
        id: 'company.updated',
        defaultMessage: 'Company updated'
    },

    companyDeleted: {
        id: 'company.deleted',
        defaultMessage: 'Company deleted'
    },
    companyDeleteError: {
        id: 'company.delete.error',
        defaultMessage: 'Could not delete company'
    },
    companyProfileData: {
        id: 'company.profile.data',
        defaultMessage: 'Profile data'
    },
    companyRecruiterId: {
        id: 'company.recruiter.id',
        defaultMessage: 'Recruiter id'
    },
    companyRecruiterIdDescription: {
        id: 'company.profile.recruiter.id.description',
        defaultMessage: 'Identity number recruits from'
    },
    keywordsNumber: {
        id: 'keywords.number',
        defaultMessage: 'Keywords number'
    },
    companyGeneralInfo: {
        id: 'company.general.info',
        defaultMessage: 'General info'
    },
    companyYouTubeText: {
        id: 'company.youtube.text',
        defaultMessage: 'Enter the link to a YouTube video to show the video with your profile.'
    },
    companyCategoriesTitle: {
        id: 'company.categories.title',
        defaultMessage: 'Categories'
    },
    companyCategoriesFormLabel: {
        id: 'company.categories.label',
        defaultMessage: 'Categories',
    },
    companyCategoriesFormInputPlaceholder: {
        id: 'company.categories.formInputPlaceholder',
        defaultMessage: 'Add categories',
    },
    companyDeleteModalTitle: {
        id: 'company.delete.modal.title',
        defaultMessage: 'Company deletion'
    },
    companyDeleteQuestion: {
        id: 'company.delete.questions',
        defaultMessage: 'Are you sure you want to delete this company?'
    },
    companyListTitle: {
        id: 'company.list.title',
        defaultMessage: 'Company'
    },
    companyRestore: {
        id: 'company.restore',
        defaultMessage: 'Restore company'
    },
    chooseCategories: {
        id: 'choose.categories',
        defaultMessage: 'Choose categories'
    },
    loginAs: {
        id: 'login.as',
        defaultMessage: 'Log in as'
    },
    fax: {
        id: 'fax',
        defaultMessage: 'Fax'
    },
    companyHomePage: {
        id: 'company.homepage',
        defaultMessage: 'Home page'
    },
    socialMediaLinks: {
        id: 'social.media.links',
        defaultMessage: 'Social media links'
    },
    employees: {
        id: 'employees',
        defaultMessage: 'Employees'
    },
    other: {
        id: 'other',
        defaultMessage: 'Other'
    },
    companyContactOptions: {
        id: 'company.contact.options',
        defaultMessage: 'Contact options'
    },
    portals: {
        id: 'portals',
        defaultMessage: 'Portals'
    },
    keywordsDescription: {
        id: 'keywords.description',
        defaultMessage: 'Keywords separated by comma'
    },
    companyPhoneNumber: {
        id: 'company.phone.number',
        defaultMessage: 'P number'
    },
    companyIdentification: {
        id: 'company.identification',
        defaultMessage: 'Identification'
    },
    cvrNumber: {
        id: 'cvr.number',
        defaultMessage: 'CVR number'
    },
    companyCvrNumberDescription: {
        id: 'company.cvr.number.description',
        defaultMessage: 'In addition to a CVR number, a company may also assign a so-called P-number' +
        ' (production unit number) for each geographical' +
        ' location the company has. The P-number is a 10-digit unique number.'
    },
    companyLogo: {
        id: 'company.logo',
        defaultMessage: 'Logo'
    },
    certificates: {
        id: 'certificates',
        defaultMessage: 'Certificates'
    },
    certificatesAdded: {
        id: 'certificates.added',
        defaultMessage: 'Certificates added'
    },
    certificatesUpdateError: {
        id: 'certificates.update.error',
        defaultMessage: 'Could not update certificates.'
    },
    quickSearch: {
        id: 'quick.search',
        defaultMessage: 'Quick search'
    },
    product: {
        id: 'product',
        defaultMessage: 'product'
    },
    productCreated: {
        id: 'product.created',
        defaultMessage: 'Product created'
    },
    productUpdated: {
        id: 'product.updated',
        defaultMessage: 'Product updated'
    },
    productAllowComments: {
        id: 'product.allow.comments',
        defaultMessage: 'Allow visitors to comment and ask questions about products, etc.'
    },
    productsContactPersonDescription: {
        id: 'product.contact.person.description',
        defaultMessage: 'Choose who in your company there should be a contact person.' +
        ' Among other things, the person will receive an e-mail when commenting on products etc..' +
        ' If the desired person is not listed, you must first create him.' +
        ' You can do this from the following page, but be aware that it requires administrator privileges.'
    },
    manufacturer: {
        id: 'manufacturer',
        defaultMessage: 'Manufacturer'
    },
    dealer: {
        id: 'dealer',
        defaultMessage: 'Dealer'
    },
    manufacturerOrDealer: {
        id: 'product.manufacturer.or.dealer',
        defaultMessage: 'Manufacturer/Dealer'
    },
    supplierCompetencies: {
        id: 'supplier.competencies',
        defaultMessage: 'Supplier competencies'
    },
    supplierCompetenciesAdded: {
        id: 'supplier.competencies.added',
        defaultMessage: 'Competencies added'
    },
    supplierCompetenciesUpdateError: {
        id: 'supplier.competencies.update.error',
        defaultMessage: 'Could not update supplier competencies.'
    },
    supplierCompetenciesDontBelongToUser: {
        id: 'supplier.competencies.dont.belong.to.user',
        defaultMessage: 'Could not be your supplier\'s competencies.'
    },
    supplierCompetenciesSelect: {
        id: 'supplier.competencies.select',
        defaultMessage: 'Select competencies'
    },
    supplierCompetenciesSelectPlaceholder: {
        id: 'supplier.competencies.select.placeholder',
        defaultMessage: 'Select supplier competencies'
    },
    multistepSelectButtonGroupResetButton: {
        id: 'multistep-select.button.group.reset.button',
        defaultMessage: 'Reset'
    },
    multistepSelectInputGroupPlaceholder: {
        id: 'multistep-select.input.group.placeholder',
        defaultMessage: 'Select...'
    },
    multistepSelectButtonSelectionPlaceholder: {
        id: 'multistep-select.button.group.placeholder',
        defaultMessage: 'Select \'{selectedItemName}\''
    },
    multistepSelectButtonSelectionSubItemPlaceholder: {
        id: 'multistep-select.button.group.subitem.placeholder',
        defaultMessage: 'Select sub item \'{selectedItemName}\''
    },
    multistepSelectInputMaxLengthError: {
        id: 'multistep-select.input.maxLengthError',
        defaultMessage: 'Too long value'
    },
    price: {
        id: 'price',
        defaultMessage: 'Price'
    },
    priceVat: {
        id: 'price.excl.vat',
        defaultMessage: 'Price excl. VAT'
    },
    filesSelectOrDrug: {
        id: 'files.select.or.drug',
        defaultMessage: 'Select files or drag files here'
    },
    filesErrorCantUploadThisFile: {
        id: 'files.cant.upload.this.file',
        defaultMessage: 'You can not upload files of this type.'
    },
    filesCancelUpload: {
        id: 'files.cancel.upload',
        defaultMessage: 'Cancel upload'
    },
    filesAreYouSureCancelUpload: {
        id: 'files.are.you.sure.cancel.upload',
        defaultMessage: 'Are you sure you want to cancel this upload?'
    },
    filesRemoveImage: {
        id: 'files.remove.image',
        defaultMessage: 'Remove Image'
    },
    filesRemoveFile: {
        id: 'files.remove.file',
        defaultMessage: 'Remove file'
    },
    filesCantUploadMore: {
        id: 'files.cant.upload.more',
        defaultMessage: 'You can not upload more files.'
    },
    filesMaxSize: {
        id: 'files.max.size',
        defaultMessage: 'Maximum file size'
    },
    videoSelectSource: {
        id: 'video.select.source',
        defaultMessage: 'Select source'
    },
    vimeoCompanyAccessError: {
        id: 'vimeo.companyAccess.error',
        defaultMessage: 'Video owner is company "{companyName}" and you cannot use this video!'
    },
    userProfileErrorGetUser: {
        id: 'user.profile.error.get.user',
        defaultMessage: 'There was a server error:'
    },
    userProfileWeBeginToPrepareData: {
        id: 'user.profile.we.begin.to.prepare.data',
        defaultMessage: 'We began to prepare your data'
    },
    userProfileEmailSent: {
        id: 'user.profile.email.sent',
        defaultMessage: 'We\'ve sent you an email with more information.'
    },
    userProfileNoInformationProvided: {
        id: 'user.profile.no.information.provided',
        defaultMessage: 'No information is provided.'
    },
    userProfilePageTitle: {
        id: 'user.profile.page.title',
        defaultMessage: 'My profile'
    },
    userProfileName: {
        id: 'user.profile.name',
        defaultMessage: 'User profile'
    },
    userProfileWorkingTitle: {
        id: 'user.profile.working.title',
        defaultMessage: 'Working title'
    },
    userProfileEmail: {
        id: 'user.profile.email',
        defaultMessage: 'Email'
    },
    userProfileAddress: {
        id: 'user.profile.address',
        defaultMessage: 'Address'
    },
    userProfileStreetName: {
        id: 'user.profile.street.name',
        defaultMessage: 'Street name'
    },
    userProfilePhone: {
        id: 'user.profile.phone',
        defaultMessage: 'Phone'
    },
    userProfileMobilePhone: {
        id: 'user.profile.mobile.phone',
        defaultMessage: 'Mobile phone'
    },
    userProfileDirectPhoneNumber: {
        id: 'user.profile.direct.phone.number',
        defaultMessage: 'Direct phone number'
    },
    userProfileEditButton: {
        id: 'user.profile.edit.button',
        defaultMessage: 'Edit'
    },
    userProfileDeleteProfileButton: {
        id: 'user.profile.delete.profile.button',
        defaultMessage: 'Delete profile'
    },
    userProfileDescription: {
        id: 'user.profile.description',
        defaultMessage: 'Here you can update and edit your personal information,' +
        ' change your password and customize your information mail.' +
        ' It is also here that you get an overview of the companies that you monitor and follow.'
    },
    userProfilePersonalInformation: {
        id: 'user.profile.personal.information',
        defaultMessage: 'Personal Information'
    },
    userProfileDownloadMyDataButton: {
        id: 'user.profile.download.my.data.button',
        defaultMessage: 'Download my data'
    },
    sideBarCreateMenuTitle: {
        id: 'side.bar.create.menu.title',
        defaultMessage: 'Create'
    },
    sideBarCreateItemArticle: {
        id: 'side.bar.create.item.article',
        defaultMessage: 'Article'
    },
    sideBarCreateItemJob: {
        id: 'side.bar.create.item.job',
        defaultMessage: 'Job'
    },
    sideBarCreateItemMachine: {
        id: 'side.bar.create.item.machine',
        defaultMessage: 'Machine'
    },
    sideBarCreateItemService: {
        id: 'side.bar.create.item.service',
        defaultMessage: 'Service'
    },
    sideBarCreateItemContactPerson: {
        id: 'side.bar.create.item.contact.person',
        defaultMessage: 'Contact person'
    },
    sideBarCreateItemCourse: {
        id: 'side.bar.create.item.course',
        defaultMessage: 'Course'
    },
    sideBarCreateItemCatalog: {
        id: 'side.bar.create.item.catalog',
        defaultMessage: 'Catalog'
    },
    sideBarListMenuTitle: {
        id: 'side.bar.list.menu.title',
        defaultMessage: 'Lists'
    },
    sideBarListItemArticles: {
        id: 'side.bar.list.item.articles',
        defaultMessage: 'Articles'
    },
    sideBarListItemJobs: {
        id: 'side.bar.list.item.jobs',
        defaultMessage: 'Jobs'
    },
    sideBarListItemMachines: {
        id: 'side.bar.list.item.machines',
        defaultMessage: 'Machines'
    },
    sideBarListItemServices: {
        id: 'side.bar.list.item.services',
        defaultMessage: 'Services'
    },
    sideBarListItemContactPersons: {
        id: 'side.bar.list.item.contact.persons',
        defaultMessage: 'Contact persons'
    },
    sideBarListItemCourses: {
        id: 'side.bar.list.item.courses',
        defaultMessage: 'Courses'
    },
    sideBarListItemCatalogs: {
        id: 'side.bar.list.item.catalogs',
        defaultMessage: 'Catalogs'
    },
    sideBarProfileMenuItemTitle: {
        id: 'side.bar.profile.menu.item.title',
        defaultMessage: 'Profile'
    },
    sideBarProfileItemCompanyProfile: {
        id: 'side.bar.profile.item.company.profile',
        defaultMessage: 'Company profile'
    },
    sideBarProfileItemCertificates: {
        id: 'side.bar.profile.item.certificates',
        defaultMessage: 'Certificates'
    },
    sideBarProfileItemProducts: {
        id: 'side.bar.profile.item.products',
        defaultMessage: 'Products'
    },
    sideBarProfileItemSupplierCompetencies: {
        id: 'side.bar.profile.item.supplier.competencies',
        defaultMessage: 'Competencies'
    },
    sideBarProfileItemAdministerCompetencies: {
        id: 'side.bar.profile.item.admin.competencies',
        defaultMessage: 'Administer competencies'
    },
    sideBarWebMasterCreateCompanyProfile: {
        id: 'side.bar.web.master.create.company.profile',
        defaultMessage: 'Company profile'
    },
    sideBarWebMasterUserList: {
        id: 'side.bar.web.master.user.list',
        defaultMessage: 'Users'
    },
    sideBarWebMasterCompanyList: {
        id: 'side.bar.web.master.company.list',
        defaultMessage: 'Companies'
    },
    sideBarWebMasterPortalContactList: {
        id: 'side.bar.web.master.portal.contact.list',
        defaultMessage: 'Portal contacts'
    },
    sideBarWebMasterPortalDepartmentList: {
        id: 'side.bar.web.master.department.list',
        defaultMessage: 'Departments'
    },
    sideBarWebMasterTipList: {
        id: 'side.bar.web.master.tip.list',
        defaultMessage: 'Tips'
    },
    sideBarWebMasterCategories: {
        id: 'side.bar.web.master.categories',
        defaultMessage: 'Categories'
    },
    sideBarNavMenuTitle: {
        id: 'side.bar.nav.menu.title',
        defaultMessage: 'Manage on all media'
    },
    topBarUserProfile: {
        id: 'top.bar.user.profile',
        defaultMessage: 'User profile'
    },
    topBarCompanyProfile: {
        id: 'top.bar.company.profile',
        defaultMessage: 'Company profile'
    },
    topBarStatistics: {
        id: 'top.bar.statistics',
        defaultMessage: 'Statistics'
    },
    topBarSettings: {
        id: 'top.bar.settings',
        defaultMessage: 'Settings'
    },
    topBarLabelSystem: {
        id: 'top.bar.label.system',
        defaultMessage: 'System'
    },
    topBarLabelActions: {
        id: 'top.bar.label.actions',
        defaultMessage: 'Actions'
    },
    topBarLabelLogOut: {
        id: 'top.bar.label.log.out',
        defaultMessage: 'Log out'
    },
    topBarPageTitle: {
        id: 'top.bar.page.title',
        defaultMessage: 'Members'
    },
    topBarLoggedAs: {
        id: 'top.bar.logged.as',
        defaultMessage: 'Logged as'
    },
    updating: {
        id: 'button.text.updating',
        defaultMessage: 'Updating...'
    },
    usersDeleteOwnError: {
        id: 'users.delete.own.error',
        defaultMessage: 'You can not delete your account'
    },
    usersDeleteUserError: {
        id: 'users.delete.error',
        defaultMessage: 'Could not delete user'
    },
    usersUserDeleted: {
        id: 'users.user.deleted',
        defaultMessage: 'User deleted'
    },
    usersDeleteModalTitle: {
        id: 'users.delete.modal.title',
        defaultMessage: 'Deleting users'
    },
    usersDeleteQuestion: {
        id: 'users.delete.question',
        defaultMessage: 'Are you sure you want to delete this user?'
    },
    userListTitle: {
        id: 'user.list.title',
        defaultMessage: 'Users'
    },
    userListCreate: {
        id: 'user.list.create',
        defaultMessage: 'Create users'
    },
    usersEditUser: {
        id: 'users.edit.user',
        defaultMessage: 'Edit user'
    },
    usersCreateUser: {
        id: 'users.create.user',
        defaultMessage: 'Create user'
    },
    userProfileUpdated: {
        id: 'user.profile.updated',
        defaultMessage: 'User data updated'
    },
    editUserProfile: {
        id: 'edit.user.profile',
        defaultMessage: 'Edit profile'
    },
    userDeleteProfileError: {
        id: 'user.delete.profile.error',
        defaultMessage: 'Profile deletion error'
    },
    userDeleteMyProfile: {
        id: 'user.delete.my.profile',
        defaultMessage: 'Delete my profile'
    },
    userDeleteProfileDescription: {
        id: 'user.delete.profile.description',
        defaultMessage: 'Description of the profile deletion procedure'
    },
    userWantDownload: {
        id: 'user.want.download',
        defaultMessage: 'You may want to download your data before deletion of you profile'
    },
    userDownloadData: {
        id: 'user.download.data',
        defaultMessage: 'Download my data'
    },
    tips: {
        id: 'tips',
        defaultMessage: 'Tips'
    },
    tipUpdated: {
        id: 'tip.updated',
        defaultMessage: 'Tip updated'
    },
    tipCreated: {
        id: 'tip.created',
        defaultMessage: 'Tip created'
    },
    tipCloned: {
        id: 'tip.cloned',
        defaultMessage: 'Tip copied'
    },
    tipDeleted: {
        id: 'tip.deleted',
        defaultMessage: 'Tip deleted'
    },
    createTips: {
        id: 'tip.create',
        defaultMessage: 'Create tips'
    },
    tipDeleteModalTitle: {
        id: 'tip.delete.modal.title',
        defaultMessage: 'Tip deletion'
    },
    departmentsDeleteError: {
        id: 'department.delete.error',
        defaultMessage: 'Could not delete department'
    },
    departmentDeleted: {
        id: 'department.deleted',
        defaultMessage: 'Department deleted'
    },
    department: {
        id: 'department',
        defaultMessage: 'Department'
    },
    departments: {
        id: 'departments',
        defaultMessage: 'Departments'
    },
    departmentsDeleteModalTitle: {
        id: 'departments.delete.modal.title',
        defaultMessage: 'Department deletion'
    },
    departmentsDeleteQuestion: {
        id: 'departments.delete.question',
        defaultMessage: 'Are you sure you want to delete this department?'
    },
    departmentUpdated: {
        id: 'department.updated',
        defaultMessage: 'Department updated'
    },
    departmentCreated: {
        id: 'department.created',
        defaultMessage: 'Department created'
    },
    departmentCreate: {
        id: 'department.create',
        defaultMessage: 'Create department'
    },
    portalContact: {
        id: 'portal.contact',
        defaultMessage: 'Portal contact'
    },
    portalContacts: {
        id: 'portal.contacts',
        defaultMessage: 'Portal contacts'
    },
    portalContactDeleteError: {
        id: 'portal.contact.delete.error',
        defaultMessage: 'Could not delete contact'
    },
    portalContactDeleted: {
        id: 'portal.contact.deleted',
        defaultMessage: 'Contact deleted'
    },
    portalContactCreate: {
        id: 'portal.contact.create',
        defaultMessage: 'Create portal contact'
    },
    portalContactDeleteModalTitle: {
        id: 'portal.contact.delete.modalTitle',
        defaultMessage: 'Portal contact deletion'
    },
    portalContactDeleteQuestion: {
        id: 'portal.contact.delete.question',
        defaultMessage: 'Are you sure you want to delete this contact?'
    },
    portalContactUpdated: {
        id: 'portalContactUpdated',
        defaultMessage: 'Contact updated'
    },
    portalContactCreated: {
        id: 'portalContactCreated',
        defaultMessage: 'Contact created'
    },
    portal: {
        id: 'portal',
        defaultMessage: 'Portal'
    },
    order: {
        id: 'order',
        defaultMessage: 'Order'
    },
    somethingWrong: {
        id: 'something.wrong',
        defaultMessage: 'Something wrong happened'
    },
    cannotChangeOwnValue: {
        id: 'cant.change.own.value',
        defaultMessage: 'You can not change value for yourself!'
    },
    selectCompany: {
        id: 'select.company',
        defaultMessage: 'Select a company'
    },
    noName: {
        id: 'noname',
        defaultMessage: 'No name'
    },
    company: {
        id: 'company',
        defaultMessage: 'Company'
    },
    mobile: {
        id: 'mobile',
        defaultMessage: 'Mobile'
    },
    showVCARD: {
        id: 'show.vcard',
        defaultMessage: 'Show VCARD'
    },
    password: {
        id: 'password',
        defaultMessage: 'Password'
    },
    portraitPhoto: {
        id: 'portrait.photo',
        defaultMessage: 'Portrait photo'
    },
    regions: {
        id: 'regions',
        defaultMessage: 'Regions'
    },
    municipalities: {
        id: 'municipalities',
        defaultMessage: 'Municipalities'
    },
    webmaster: {
        id: 'webmaster',
        defaultMessage: 'Webmaster'
    },
    webmasterFBG: {
        id: 'webmaster.fbg',
        defaultMessage: 'Webmaster (FBG Medier)'
    },
    actions: {
        id: 'actions',
        defaultMessage: 'Actions'
    },
    success: {
        id: 'success',
        defaultMessage: 'Success.'
    },
    select: {
        id: 'select',
        defaultMessage: 'Select...'
    },
    enterName: {
        id: 'enter.name',
        defaultMessage: 'Please enter name'
    },
    enterEmail: {
        id: 'enter.email',
        defaultMessage: 'Please enter email'
    },
    enterOrder: {
        id: 'enter.order',
        defaultMessage: 'Please enter order'
    },
    invalidEmail: {
        id: 'invalid.email',
        defaultMessage: 'Invalid email address'
    },
    invalidPhone: {
        id: 'invalid.phone',
        defaultMessage: 'Invalid phone number'
    },
    invalidMobile: {
        id: 'invalid.mobile.phone',
        defaultMessage: 'Invalid mobile phone number'
    },
    invalidDirectPhone: {
        id: 'invalid.direct.phone',
        defaultMessage: 'Invalid direct phone number'
    },
    invalidFax: {
        id: 'invalid.fax',
        defaultMessage: 'Invalid fax number'
    },
    selectDepartment: {
        id: 'select.department',
        defaultMessage: 'Select department'
    },
    selectPortalType: {
        id: 'select.portal.type',
        defaultMessage: 'Select portal type'
    },
    errorTooShort3: {
        id: 'error.too.short.3',
        defaultMessage: 'Must be 3 characters min'
    },
    filesMandatory: {
        id: 'files.mandatory',
        defaultMessage: 'Files are mandatory'
    },
    enterCategoryToSave: {
        id: 'enter.category.to.save',
        defaultMessage: 'Enter the categories you want to keep '
    },
    errorSelectCategories: {
        id: 'error.select.categories',
        defaultMessage: 'Please select categories '
    },
    mustBe4Digits: {
        id: 'must.be.4.digits',
        defaultMessage: 'The value must be 4 digits '
    },
    mustBe8Digits: {
        id: 'must.be.8.digits',
        defaultMessage: 'The value must be 8 digits '
    },
    mustBe10Digits: {
        id: 'must.be.10.digits',
        defaultMessage: 'The value must be 10 digits '
    },
    mustStartWithHTTP: {
        id: 'must.start.with.http',
        defaultMessage: 'Must start with http://'
    },
    incorrectCoordinates: {
        id: 'incorrect.coordinates',
        defaultMessage: 'The coordinates are incorrect '
    },
    descriptionRequired: {
        id: 'description.required',
        defaultMessage: 'Description required'
    },
    priceTooHigh: {
        id: 'price.too.high',
        defaultMessage: 'Too high price'
    },
    enterStartDate: {
        id: 'enter.start.date',
        defaultMessage: 'Please enter start date '
    },
    enterEndDate: {
        id: 'enter.end.date',
        defaultMessage: 'Please enter end date '
    },
    selectServiceType: {
        id: 'select.service.type',
        defaultMessage: 'Please select type'
    },
    selectVideoSource: {
        id: 'select.video.source',
        defaultMessage: 'Select videosource'
    },
    videoTooLarge: {
        id: 'video.too.large',
        defaultMessage: 'The video file you selected is too large. The file must not exceed 50MB'
    },
    successfulUpload: {
        id: 'successful.upload',
        defaultMessage: 'Upload successful'
    },
    checkUploadedVideo: {
        id: 'check.uploaded.video',
        defaultMessage: 'check uploaded video'
    },
    onlyVimeoVideo: {
        id: 'only.vimeo.video',
        defaultMessage: 'Only vimeo video available'
    },
    inputNotAvailable: {
        id: 'input.not.available',
        defaultMessage: 'Input is not available, please insert url to avoid errors'
    },
    vindeoName: {
        id: 'video.name',
        defaultMessage: 'Video name'
    },
    videoNotFound: {
        id: 'video.not.found',
        defaultMessage: 'Video not found'
    },
    videoPreparing: {
        id: 'video.preparing',
        defaultMessage: 'Your video has been uploaded and we are preparing to view it. It takes a few minutes ...'
    },
    enterYoutubeLink: {
        id: 'enter.youtube.link',
        defaultMessage: 'Enter the link to a YouTube video to show the video with your news.'
    },
    required: {
        id: 'required',
        defaultMessage: 'Required'
    },
    showDeletedCompaniesButtonShow: {
        id: 'show.deleted.companies.button.show',
        defaultMessage: 'Show deleted companies'
    },
    showDeletedCompaniesButtonHide: {
        id: 'show.deleted.companies.button.hide',
        defaultMessage: 'Hide deleted companies'
    },
    allPortals: {
        id: 'all.portals.title',
        defaultMessage: 'All portals'
    },
    inputLimiterKeywordsModalTitle: {
        id: 'input-limiter.keywords.modal.title',
        defaultMessage: 'Do you need more tags?',
    },
    inputLimiterKeywordsModalBodyLine1: {
        id: 'input-limiter.keywords.modal.body.line1',
        defaultMessage: 'You have the option to purchase more tags.',
    },
    inputLimiterKeywordsModalBodyLine2: {
        id: 'input-limiter.keywords.modal.body.line2',
        defaultMessage: 'Please contact the administration department for further information.',
    },
    inputLimiterButtonText: {
        id: 'input-limiter.button.text',
        defaultMessage: 'Buy more tags or keywords' // Køb flere tags eller søgeord
    },
    validationErrorLengthToLong: {
        id: 'validation.error.length.to.long',
        defaultMessage: 'The length must not exceed \'{length}\' characters'
    },
    closeModal: {
        id: 'modal.close',
        defaultMessage: 'Close'
    },
    companyFormKeywordsConfirmBtnTextSubItem: {
        id: 'company-form.keywords.confirm-btn-text.sub-item',
        defaultMessage: 'Select sub category \'{selectedItemName}\''
    },
    oldCategoriesLabel: {
        id: 'label.old-categories',
        defaultMessage: 'Old categories',
    },
    deleteOldCategoriesButton: {
        id: 'button.delete-old-categories',
        defaultMessage: 'Delete categories',
    },
    maxCategoriesCount: {
        id: 'sub-label.max-categories-count',
        defaultMessage: 'Max 3 category'
    },
    categoriesWebmasterModalTitle: {
        id: 'categoriesWebmaster.modal.title',
        defaultMessage: 'Confirm the deletion'
    },
    categoriesWebmasterModalBody: {
        id: 'categoriesWebmaster.modal.body',
        defaultMessage: 'Sure?'
    },
    categoriesWebmasterModalCancelBtn: {
        id: 'categoriesWebmaster.modal.cancelBtn',
        defaultMessage: 'Delete'
    },
    categoriesWebmasterModalConfirmBtn: {
        id: 'categoriesWebmaster.modal.confirmBtn',
        defaultMessage: 'Cancel'
    },
    categoriesWebmasterCreateModalTitle: {
        id: 'categories.webmaster.create.modal.title',
        defaultMessage: 'Create category'
    },
    categoriesWebmasterCreateModalBtn: {
        id: 'categories.webmaster.create.modal.btn',
        defaultMessage: 'Create'
    },
    categoriesWebmasterCreateFormInputName: {
        id: 'categories.webmaster.create.form.input.name',
        defaultMessage: 'Name'
    },
    categoriesWebmasterCreateFormInputHint: {
        id: 'categories.webmaster.create.form.input.hint',
        defaultMessage: 'Please give a name to the category'
    },
    categoriesWebmasterCreateFormCategoriesListLabel: {
        id: 'categories.webmaster.create.form.categories.list.label',
        defaultMessage: 'Select parent category'
    },
    categoriesWebmasterCreateBtn: {
        id: 'categories.webmaster.create.btn',
        defaultMessage: 'Create'
    },
    categoriesWebmasterTreeNodeEditBtn: {
        id: 'categories.webmaster.tree.node.edit.btn',
        defaultMessage: 'Edit'
    },
    categoriesWebmasterTreeNodeDeleteBtn: {
        id: 'categories.webmaster.tree.node.delete.btn',
        defaultMessage: 'Delete'
    },
    categoriesWebmasterTreeNodeUsed: {
        id: 'categories.webmaster.tree.node.used',
        defaultMessage: 'Category is in use'
    },
    categoriesWebmasterTreeNodeHasChildren: {
        id: 'categories.webmaster.tree.node.has.children',
        defaultMessage: 'Category has children'
    },
    categoriesWebmasterCategoryCreated: {
        id: 'categories.webmaster.category.created',
        defaultMessage: 'Category created'
    },
    categoriesWebmasterCatNameUpdated: {
        id: 'categories.webmaster.category.name.updated',
        defaultMessage: 'Category name updated'
    },
    categoriesWebmasterCatPositionUpdated: {
        id: 'categories.webmaster.category.position.updated',
        defaultMessage: 'Category position updated'
    },
    categoriesWebmasterCategoryDeleted: {
        id: 'categories.webmaster.category.deleted',
        defaultMessage: 'Category deleted'
    },
    competenciesWebmasterComCreated: {
        id: 'competencies.webmaster.competency.created',
        defaultMessage: 'Competency created'
    },
    competenciesWebmasterComNameUpdated: {
        id: 'competencies.webmaster.competency.name.updated',
        defaultMessage: 'Competency name updated'
    },
    competenciesWebmasterComPosUpdated: {
        id: 'competencies.webmaster.competency.position.updated',
        defaultMessage: 'Competency position updated'
    },
    competenciesWebmasterComDeleted: {
        id: 'competencies.webmaster.com.deleted',
        defaultMessage: 'Competency deleted'
    },
    competenciesWebmasterComUsed: {
        id: 'competencies.webmaster.com.used',
        defaultMessage: 'Competency is in use'
    },
    competenciesWebmasterComHasChildren: {
        id: 'competencies.webmaster.com.has.children',
        defaultMessage: 'Competency has children'
    },
    competenciesWebmasterCreateModalTitle: {
        id: 'competencies.webmaster.create.modal.title',
        defaultMessage: 'Create competency'
    },
    competenciesWebmasterCreateFormInputHint: {
        id: 'competencies.webmaster.create.form.input.hint',
        defaultMessage: 'Please give a name to the competency'
    },
    competenciesWebmasterCreateFormComListLabel: {
        id: 'competencies.webmaster.create.form.com.list.label',
        defaultMessage: 'Select parent competency'
    },
    interests: {
        id: 'title.interests',
        defaultMessage: 'Interests'
    },
    interestsFormUpdated: {
        id: 'form.interests.updated',
        defaultMessage: 'Interests updated'
    },
    articleCategoryCreate: {
        id: 'article.category.create',
        defaultMessage: 'Create article category'
    },
    articleCategoryUpdate: {
        id: 'article.category.update',
        defaultMessage: 'Update article category'
    },
    articleCategoryCreated: {
        id: 'article.category.created',
        defaultMessage: 'Article category created'
    },
    articleCategoryUpdated: {
        id: 'article.category.updated',
        defaultMessage: 'Article category updated'
    },
    articleCategoryCreateButton: {
        id: 'article.category.button.create',
        defaultMessage: 'Create Article category'
    },
    articleCategoryDeleteQuestion: {
        id: 'article.category.delete.question',
        defaultMessage: 'Are you sure?'
    },
    articleCategoriesList: {
        id: 'article.categories.list',
        defaultMessage: 'Article categories'
    },
    articleCategoryDelete: {
        id: 'article.category.delete',
        defaultMessage: 'Delete article category'
    },
    articleCategoryDeleted: {
        id: 'article.category.deleted',
        defaultMessage: 'Article category deleted'
    },
    articleCategoryDeleteError: {
        id: 'article.category.delete.error',
        defaultMessage: 'Error on article delete'
    },
    articleCategoryInputDescription: {
        id: 'article.category.input.description',
        defaultMessage: 'Description'
    },
    articleCategoryInputName: {
        id: 'article.category.input.name',
        defaultMessage: 'Name'
    },
    articleCategoryStatusDeactivated: {
        id: 'article.category.status.deactivated',
        defaultMessage: 'Deactivated'
    },
    articleCategoryStatusActive: {
        id: 'article.category.status.activate',
        defaultMessage: 'Active'
    },
    articleCategoryMessageStatusActivated: {
        id: 'article.category.message.status.activated',
        defaultMessage: 'Category Activated'
    },
    articleCategoryMessageStatusDeactivated: {
        id: 'article.category.message.status.deactivated',
        defaultMessage: 'Category deactivated'
    },
    articleCategoryStatusReactivate: {
        id: 'article.category.status.reactivate',
        defaultMessage: 'Reactivate'
    },
    articleCategoryListDescription: {
        id: 'article.category.list.description',
        defaultMessage: 'Description'
    },
    articleCategoryListName: {
        id: 'article.category.list.name',
        defaultMessage: 'Name'
    },
    articleCategoryListOptions: {
        id: 'article.category.list.options',
        defaultMessage: 'Options'
    },
    articleCategoryListStatus: {
        id: 'article.category.list.status',
        defaultMessage: 'Status'
    },
    articleCategoryListWarningArticlesAmount: {
        id: 'article.category.list.warning.articles.amount',
        defaultMessage: 'This category is present in "{amount}" of articles, are you sure? '
    },
    articleCategoryListPortalNotAssigned: {
        id: 'article.category.list.portal.not.assigned',
        defaultMessage: 'not assigned'
    },
    articleCategoryListPortalLabel: {
        id: 'article.category.list.portal.label',
        defaultMessage: 'Portal'
    },
    articleCategoryShowDeactivatedButton: {
        id: 'article.category.show.deactivated.button',
        defaultMessage: 'Show deactivated'
    },
    articleCategoryHideDeactivatedButton: {
        id: 'article.category.hide.deactivated.button',
        defaultMessage: 'Hide deactivated'
    },
    resetModalTitle: {
        id: 'reset.modal.title',
        defaultMessage: 'Cancel your changes'
    },
    resetModalMessage: {
        id: 'reset.modal.message',
        defaultMessage: 'Are you sure, you want to cancel? All of your alterations will be lost.'
    },
    buttonYes: {
        id: 'button.yes',
        defaultMessage: 'Yes'
    },
    buttonNo: {
        id: 'button.no',
        defaultMessage: 'No'
    }
});


// WEBPACK FOOTER //
// ./web/src/components/common/Translations.jsx